import { io, Socket } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
class SocketService {
    private socket: Socket | null = null;

    connect() {
        if (this.socket?.connected) return;

        const token = localStorage.getItem('jwtToken');

        this.socket = io(SOCKET_URL, {
            auth: {
                token: token,
                type: 'admin'
            },
            transports: ['websocket'],
            reconnection: true,
        });

        this.socket.on('connect', () => {
            console.log('[Socket] Connected:', this.socket?.id);
        });

        this.socket.on('connect_error', (err: any) => {
            console.error('[Socket] Connection Error:', err);
        });
    }

    joinRoom(chatRoomId: number) {
        if (!this.socket) this.connect();
        this.socket?.emit('join_room', { chatRoomId });
    }

    leaveRoom(chatRoomId: number) {
        if (!this.socket) return;
        this.socket.emit('leave_room', { chatRoomId });
    }

    onMessageReceived(callback: (message: any) => void) {
        if (!this.socket) return;
        this.socket.on('receive_message', (payload: any) => {
            console.log('[Socket] Message Received:', payload);
            callback(payload);
        });
    }

    offMessageReceived() {
        this.socket?.off('receive_message');
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
    }
}

export const socketService = new SocketService();